import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { ClickOutsideModule } from 'ng-click-outside';

import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { PipeModule } from 'app/shared/pipes/pipe.module';

//COMPONENTS
import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from "./vertical-menu/vertical-menu.component";
import { CustomizerComponent } from './customizer/customizer.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';
import { StockHeaderComponent } from './stock-header/stock-header.component';
//DIRECTIVES
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';
import { CommonSearchViewComponent } from './modals/commonsearchview.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbdSortableHeader } from './directives/sortable.directive';
import { EmployeedetailsComponent } from './employeedetails/employeedetails.component';
import { DesignationSearchComponent } from './designation-search/designation-search.component';
import { EmployeesearchComponent } from './employeesearch/employeesearch.component';
import { EmployeeSearchViewComponent } from './employee-search-view/employee-search-view.component';
// import { ClipboardModule } from 'ngx-clipboard';
import { NumbermodalComponent } from './numbermodal/numbermodal.component';
import { DrawerComponent } from './drawer/drawer.component';
import { NoSanitizePipe } from 'app/pipe/NoSanitizePipe.pipe';
import { LoaderComponent } from './loader/loader.component';
// import { OPDDashBoardComponent } from 'app/Examination/opddash-board/opddash-board.component';
// import { ReferralListReportCriteriaComponent } from 'app/Examination/referral-list-report-criteria/referral-list-report-criteria.component';
// import { PeriodicSearchComponent } from 'app/Examination/periodic-search/periodic-search.component';
@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective, 
        SidebarDirective,
        NgbdSortableHeader,
        TopMenuDirective,
        NgbModule,
        TranslateModule,
        CommonSearchViewComponent,
        EmployeedetailsComponent,
        EmployeesearchComponent,
        NumbermodalComponent,
        DrawerComponent,
        NoSanitizePipe,
        LoaderComponent,
        StockHeaderComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        FormsModule,
        OverlayModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        ClickOutsideModule,
        AutocompleteModule,
        PipeModule,
        NgxDatatableModule
        // ,ClipboardModule
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarLinkDirective,
        SidebarDropdownDirective,
        SidebarAnchorToggleDirective,
        SidebarDirective, NgbdSortableHeader,
        TopMenuLinkDirective,
        TopMenuDropdownDirective,
        TopMenuAnchorToggleDirective,
        TopMenuDirective,
        CommonSearchViewComponent,
        EmployeedetailsComponent,
        DesignationSearchComponent,
        NumbermodalComponent,
        EmployeeSearchViewComponent,
        EmployeesearchComponent,
        DrawerComponent,
        NoSanitizePipe,
        LoaderComponent,
        StockHeaderComponent
        // OPDDashBoardComponent,
        // ReferralListReportCriteriaComponent,
        // PeriodicSearchComponent
    ],
    entryComponents: [DesignationSearchComponent],
})
export class SharedModule { }
